import { render, staticRenderFns } from "./model_make.vue?vue&type=template&id=53c5c7cc&scoped=true"
import script from "./model_make.vue?vue&type=script&lang=js"
export * from "./model_make.vue?vue&type=script&lang=js"
import style0 from "./model_make.vue?vue&type=style&index=0&id=53c5c7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5c7cc",
  null
  
)

export default component.exports